export const Stage = {
  Early: -200,
  Physics: -100,
  Normal: 0,
  Late: 100,
  Render: 200
}
